import { msg } from "@omegagrid/localize";
import { NodeModel, TreeOptions, TreeSource } from "@omegagrid/tree";
import { BrowserAdapter } from "@reporting/rp-app-host";;

export class SuperBrowserAdapter extends BrowserAdapter {

	async getTree(): Promise<TreeSource> {
		const items: TreeSource = [];
		items.push({ // groups
			k: 'groups',
			v: msg('Groups'),
			l: 0,
			collapsed: true,
			folder: {
				openIcon: {icon: ['fas', 'folder-open'], color: 'SteelBlue', statusIcon: ['fas', 'building'], statusColor: 'Orange'},
				closedIcon: {icon: ['fas', 'folder'], color: 'SteelBlue', statusIcon: ['fas', 'building'], statusColor: 'Orange'},
			},
		}, {
			k: `accounting-groupsContainer`,
			v: msg('Companies'),
			l: 1,
			icon: { icon: 'building', color: 'Orange' }
		}, {
			k: `accounting-limits`,
			v: msg('Limits'),
			l: 1,
			icon: { icon: 'gauge-max', color: 'Orange' }
		});
		items.push({ // users
			k: 'users',
			v: msg('Users'),
			l: 0,
			collapsed: true,
			folder: {
				openIcon: {icon: ['fas', 'folder-open'], color: 'DarkGreen', statusIcon: ['fas', 'users'], statusColor: 'MediumSeaGreen'},
				closedIcon: {icon: ['fas', 'folder'], color: 'DarkGreen', statusIcon: ['fas', 'users'], statusColor: 'MediumSeaGreen'},
			},
		}, {
			k: `users-usersContainer`,
			v: msg('Users'),
			l: 1,
			icon: { icon: 'user', color: 'MediumSeaGreen' }
		}, {
			k: `users-userGroupsContainer`,
			v: msg('User groups'),
			l: 1,
			icon: { icon: 'users', color: 'MediumSeaGreen' }
		}, {
			k: `users-userAccessSuperContainer`,
			v: `${msg('Access')} - ${msg('Application')}`,
			l: 1,
			icon: { icon: 'key', color: 'GoldenRod' }
		});
		items.push({ // server
			k: 'server',
			v: msg('Server'),
			l: 0,
			collapsed: true,
			folder: {
				openIcon: {icon: ['fas', 'folder-open'], color: 'DarkOliveGreen', statusIcon: ['fas', 'database'], statusColor: 'CornflowerBlue'},
				closedIcon: {icon: ['fas', 'folder'], color: 'DarkOliveGreen', statusIcon: ['fas', 'database'], statusColor: 'CornflowerBlue'},
			},
		}, {
			k: `super-jobActivityContainer`,
			v: msg('Job activity monitor'),
			l: 1,
			icon: { icon: 'stopwatch', color: 'DarkRed', statusIcon: ['fas', 'database'], statusColor: 'GoldenRod' }
		}, {
			k: `super-jobScheduleContainer`,
			v: msg('Plans'),
			l: 1,
			icon: { icon: 'bars-staggered', color: 'Magenta' }
		}, {
			k: `super-databaseContainer`,
			v: msg('Database'),
			l: 1,
			icon: { icon: 'database', color: 'Gainsboro' }
		}, {
			k: `super-tablesContainer`,
			v: msg('Tables'),
			l: 1,
			icon: { icon: 'table-list', color: 'CornflowerBlue' }
		}, {
			k: `super-reportStatsContainer`,
			v: msg('Report statistics'),
			l: 1,
			icon: { icon: 'files', color: 'DarkGreen' }
		}, {
			k: `super-domains`,
			v: msg('Custom domains'),
			l: 1,
			icon: { icon: 'globe', color: 'CornflowerBlue' }
		}, {
			k: `super-ssoPresets`,
			v: msg('SSO presets'),
			l: 1,
			icon: { icon: 'sensor-cloud', color: 'Plum' }
		});
		items.push({ // logging
			k: 'log',
			v: msg('Logging'),
			l: 0,
			collapsed: true,
			folder: {
				openIcon: {icon: ['fas', 'folder-open'], color: 'ForestGreen', statusIcon: ['fas', 'rectangle-list'], statusColor: 'DarkSlateGray'},
				closedIcon: {icon: ['fas', 'folder'], color: 'ForestGreen', statusIcon: ['fas', 'rectangle-list'], statusColor: 'DarkSlateGray'},
			},
		}, {
			k: `accounting-journal-super`,
			v: msg('Journal'),
			l: 1,
			icon: { icon: 'reel', color: 'DarkGreen' }
		}, {
			k: `accounting-accessLog-super`,
			v: msg('Access log'),
			l: 1,
			icon: { icon: 'reel', color: 'DarkSlateGray', statusIcon: ['fas', 'user'], statusColor: 'MediumSeaGreen' }
		}, {
			k: `accounting-emailLog`,
			v: msg('Email log'),
			l: 1,
			icon: { icon: 'envelopes', color: 'GoldenRod' }
		}, {
			k: `super-errorLog`,
			v: msg('Error log'),
			l: 1,
			icon: { icon: 'triangle-exclamation', color: 'DarkRed' }
		}, {
			k: `super-historyContainer`,
			v: msg('Change history'),
			l: 1,
			icon: { icon: 'clock-rotate-left', color: 'SteelBlue' }
		}, {
			k: `users-timesheetContainer`,
			v: msg('Timesheet'),
			l: 1,
			icon: { icon: 'stopwatch', color: 'DarkSlateBlue' }
		});
		return items;
	}

	getOptions(): Partial<TreeOptions> {
		return {
			selectMode: 'none',
			expanders: false,
		};
	}

	async onAction(key: string, node: NodeModel) {}
}
